module.exports = __webpack_public_path__ + "img/afceadbab94516f3f0eabfca20b8d3ac.07e48a68.png";